import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileCallBar from "../components/MobileCallBar";
import Hero from "../sections/Hero";
import Marquee from "../sections/Marquee";
import Services from "../sections/Services";
import HowItWorks from "../sections/HowItWorks";
import Markets from "../sections/Markets";
import About from "../sections/About";
import Faq from "../sections/Faq";
import ContactSection from "../sections/ContactSection";
import { scrollToId } from "../lib/scroll";

export default function Home() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const id = location.state?.scrollTo;
        if (id) {
            navigate(location.pathname, { replace: true, state: {} });
            const t = setTimeout(() => scrollToId(id), 120);
            return () => clearTimeout(t);
        }
    }, [location, navigate]);

    return (
        <div className="bg-white font-sans text-navy">
            <Seo
                title="Employer of Record (EOR) Services | Hexagon"
                description="Explore Employer of Record services and international employment administration for US businesses. Contact Hexagon to discuss workforce needs in supported markets."
                path="/"
            />
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Services />
                <HowItWorks />
                <Markets />
                <About />
                <Faq />
                <ContactSection />
            </main>
            <Footer />
            <div className="h-[68px] md:hidden" aria-hidden="true" />
            <MobileCallBar />
        </div>
    );
}
